import constants from './utils/constants';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import routerLoading from './router-loading';
import roles from '@/roles.json';
import store from '@/store/index';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueTimepicker from 'vue2-timepicker';
// import vuefire from 'vuefire';
import Datepicker from 'vuejs-datepicker';
import { firebaseApp } from '@/firebase';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VeeValidate from 'vee-validate';
import './style.scss';
import VueSwal from 'vue-swal';
import moment from 'moment-timezone';
import '@/models/Utils';
import axios from 'axios';
import './utils/directive/fixed';
import api from '@/api';

// Register global JS method for Android to call
(window as any).receiveDeviceIDFromApp = (deviceId: string) => {
  if (deviceId) {
    localStorage.setItem('deviceId', deviceId);
  }
};

axios.defaults.headers.common['uid'] = localStorage.getItem('UID');
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueSwal);
Vue.use(BootstrapVue);
Vue.component('datepicker', Datepicker);
// Vue.use(vuefire)
Vue.use(VueTimepicker);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.prototype.errorDefaultImg =
  'this.src="' + require('@/assets/QDO_Placeholder-2.png') + '"';
moment.tz.setDefault(process.env.VUE_APP_TZ);

let app: any = new Vue({
  router: routerLoading,
  store,
  render: h => h(App)
}).$mount('#app');

let EDCChecked = false;

try {
  store.commit('SET_IS_PAGE_LOADING_USER', true);
  firebaseApp.auth().onAuthStateChanged(user => {
    let obj = { uid: user ? user.uid : '', route: router };
    store.dispatch('LOAD_CURRENT_USER', obj);
    store.dispatch('LOAD_USER_PRIVILEGES', user ? user.uid : '');

    router.beforeEach((to, from, next) => {
      const publicPage = to.matched.some(
        record => record.meta.withoutAuth && record.meta.withoutAuth === true
      );
      if (publicPage) {
        next();
        return;
      }
      if (to.fullPath.includes('/select-table')) {
        next();
        return;
      }

      if (to.fullPath.includes('/select-building')) {
        next();
        return;
      }

      if (firebaseApp.auth().currentUser) {
        const interval = setInterval(async () => {
          if (store.state.currentUser) {
            clearInterval(interval);

            if (!EDCChecked) {
              EDCChecked = true;
              const outletCodesStr = localStorage.getItem('outletCodes') || '';
              const outletCodes = outletCodesStr
                .split(',')
                .filter(item => !!item);
              if (store.state.currentUser.Type === 'Admin' || outletCodes.length) {
                const posOrderOutlet = localStorage.getItem('pos-order-outlet');
                if (posOrderOutlet) {
                  const posOrderOutletObj = JSON.parse(posOrderOutlet);
                  await store
                    .dispatch('GetOneStoreForNewPort', posOrderOutletObj.id)
                    .then((res) => {
                      const data = res.data.result;
                      localStorage.setItem('outletData', JSON.stringify(data));
                      if (data) {
                        store.commit('UPDATE_EDC_MODEL', data.edc_model);
                      } else {
                        store.commit('UPDATE_EDC_MODEL', false);
                      }
                    })
                    .catch(() => {
                      store.commit('UPDATE_EDC_MODEL', false);
                    });
                } else {
                  await api.GetAllStoreForNewPort(
                    { page: 1, size: 1 },
                    { byField: '', isDesc: '' },
                    {},
                    localStorage.getItem('UID')
                  )
                    .then(res => {
                      try {
                        const data = res.data.result.data;
                        if (data && data.length) {
                          store.commit('UPDATE_EDC_MODEL', data[0].edc_model);
                        }
                      } catch (error) {
                        store.commit('UPDATE_EDC_MODEL', false);
                        throw error;
                      }
                    })
                    .catch(() => {
                      store.commit('UPDATE_EDC_MODEL', false);
                    });
                }
              } else {
                store.commit('UPDATE_EDC_MODEL', false);
              }
            }

            const isEDC = store.state.isEDC;

            const t = store.state.currentUser.Type.toLocaleLowerCase();

            let permission = roles[t][to.fullPath];
            // if (to.matched.some(record => (record.path.includes(':id') === true))) {
            //   const p = to.matched.filter(x => x.path.includes(':id'))
            //   permission = roles[t][p[0].path]
            // }
            if (to.matched.some(record => !!record.path)) {
              const p = to.matched.filter(x => !!x.path);
              permission = roles[t][p[0].path];
            }

            if (isEDC && to.fullPath === '/') {
              next('/edc');
            } else if (
              permission === constants.PERMISSION_D ||
              permission === constants.PERMISSION_E
            ) {
              store.dispatch('USER_PAGE_PERMISSION', permission);
              next();
            } else if (
              t === 'call center' ||
              t === 'management' ||
              t === 'merchant ops' ||
              t === 'merchant mkt' ||
              t === 'runner'
            ) {
              if (isEDC) {
                next({ path: '/' });
              } else {
                next({ path: '/order-report' });
              }
            } else {
              next({ path: '/' });
            }
          }
        }, 100);

        return;
      }

      next({ path: '/login' });
    });

    // destroy Vue and create a new one
    app.$destroy();
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  });
} catch (e) {
  console.log(e.message);
}
